import React from 'react'
import Switch from '@mui/material/Switch'
import mainContext from '../../contexts/mainContext'
import { updateIdVerifiedBadge } from '../../Controllers/userManagment/common'
import { __snackBarSeverity } from '../../constants'

const statusLabel = {
    verified: 'Verified',
    processing: 'Processing',
    requires_input: 'Failed / needs retry',
    canceled: 'Canceled'
}

const IdVerification = ({ userId, verification, badgeEnabled }) => {
    const { setSnackBar } = React.useContext(mainContext)
    const [badge, setBadge] = React.useState(!!badgeEnabled)
    const [saving, setSaving] = React.useState(false)

    React.useEffect(() => { setBadge(!!badgeEnabled) }, [badgeEnabled])

    const isVerified = verification?.status === 'verified'

    const handleToggle = async (event) => {
        const verified = event.target.checked
        setBadge(verified)
        setSaving(true)
        const res = await updateIdVerifiedBadge(userId, verified)
        setSaving(false)
        if (res?.status === 200 && !res?.data?.errors?.length) {
            setSnackBar({
                status: true,
                text: res?.data?.message || 'ID Verified badge updated',
                severity: __snackBarSeverity.success
            })
        } else {
            setBadge(!verified)
            setSnackBar({
                status: true,
                text: res?.data?.errors?.[0]?.message || 'Unable to update the ID Verified badge',
                severity: __snackBarSeverity.error
            })
        }
    }

    return (
        <>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
                <span style={{ marginRight: '8px' }}>{isVerified ? '✅' : '❌'}</span>
                <span style={{ opacity: isVerified ? 1 : 0.6 }}>
                    Stripe ID Verification
                    {verification?.status ? ` — ${statusLabel[verification.status] || verification.status}` : ' — Not started'}
                </span>
            </div>
            {verification?.status === 'requires_input' && verification?.lastErrorReason && (
                <div style={{ marginLeft: '26px', marginBottom: '4px', opacity: 0.6, fontSize: '90%' }}>
                    {verification.lastErrorReason}
                </div>
            )}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', maxWidth: '220px' }}>
                <span style={{ opacity: badge ? 1 : 0.6 }}>ID Verified badge</span>
                <Switch
                    size="small"
                    checked={badge}
                    disabled={saving}
                    onChange={handleToggle}
                    sx={{
                        // The app's global `* { box-sizing: unset !important; }` reset (src/css/base.css)
                        // breaks MUI Switch's internal thumb/track sizing — restore border-box here.
                        boxSizing: 'border-box !important',
                        '& *': { boxSizing: 'border-box !important' },
                        '& .MuiSwitch-switchBase.Mui-checked': { color: 'var(--nona-theme-color)' },
                        '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: 'var(--nona-theme-color)' },
                    }}
                />
            </div>
        </>
    )
}

export default IdVerification
